module.exports = __webpack_public_path__ + "static/assets/ab22f53825a53ec56f526a9bd3c8d9d6.png";